<template>
  <VForm :form="form" @submit="onSubmit">
    <!-- #80 + #81 + #82 -->
    <VCheckbox name="terms_and_conditions" :label="$t('substore.terms_and_conditions')" :hint="$t('substore.terms_and_conditions_hint')" required label-as-required>
      {{ $t('substore.yes_i_accept_the') }}
      <!-- #83 -->
      <a :href="hyperlinks.termsOrderLinkUrl" target="_blank">{{ hyperlinks.termsOrderLinkDisplayName }}</a>
      <!-- #84 -->
    </VCheckbox>

    <!-- #85 + #86 + #87 -->
    <VCheckbox name="conditions" :label="$t('substore.conditions')" :hint="$t('substore.conditions_hint')" required label-as-required>
      {{ $t('substore.yes_i_am_aware_of') }}
      <!-- #88 -->
      <a :href="hyperlinks.rescissionOrderLinkUrl" target="_blank">{{ hyperlinks.rescissionOrderLinkDisplayName }}</a>
      <!-- #89 -->
      {{ $t('substore.aware_of_end') }}
      <!-- #TODO: ist noch nicht nachdokumentiert -->
      <a v-if="!rescissionLong" href="#" @click.prevent="rescissionLong = true"
        >{{ $t('substore.rescission_cut') }}
        <!-- #90 --></a
      >
      <span v-else role="region" aria-live="polite">{{ $t('substore.rescission_long') }}</span>
    </VCheckbox>

    <!-- #314 + #315 + #289 + #290 -->
    <VMulticheckbox name="text_to_be_confirmed" :label="texts.additionalCheckboxHeadlineSummary" :hint="$t('substore.text_to_be_confirmed_hint')" required />

    <!-- TODO: oForm: #271, #272, #273, #274, #275, #276, #277, #278 -->

    <p v-html="texts.emailTextProductOrder"><!-- #163 --></p>

    <!-- #160 + #161 + #162 -->
    <VInput
      name="email"
      autocomplete="email"
      :model-value="customerEmail"
      :label="$t('substore.your_email')"
      :hint="$t('substore.email_hint')"
      placeholder="max.mustermann@t-online.de"
      required
      label-as-required
    />

    <!-- #329 + #330 -->
    <VInput
      name="email_verification"
      autocomplete="email"
      :model-value="customerEmail"
      :label="$t('substore.your_email_verification')"
      :hint="$t('substore.email_hint')"
      placeholder="max.mustermann@t-online.de"
      required
      label-as-required
    />

    <slot />
  </VForm>
</template>

<script>
import Form from '@/components/Form/Form';
import Input from '@/components/Form/Input';
import Checkbox from '@/components/Form/Checkbox';
import MultiCheckbox from '@/components/Form/MultiCheckbox';
import { initFields, isValidEmail, isEqualTo } from '@/utils/form';

export default {
  name: 'ProductOrderSummaryForm',

  components: {
    VForm: Form,
    VInput: Input,
    VCheckbox: Checkbox,
    VMulticheckbox: MultiCheckbox,
  },

  props: {
    hyperlinks: {
      type: Object,
      required: true,
    },

    texts: {
      type: Object,
      required: true,
    },

    textLists: {
      type: Object,
      required: true,
    },

    customerEmail: {
      type: String,
      required: false,
      default: null,
    },

    isEmailVerification: {
      type: Boolean,
      required: true,
    },

    hideTermsAndConditions: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      form: initFields(
        { name: 'terms_and_conditions', isHidden: !this.hyperlinks.termsOrderLinkUrl || this.hideTermsAndConditions },
        { name: 'conditions', isHidden: !this.hyperlinks.rescissionOrderLinkUrl || this.hideTermsAndConditions },
        {
          name: 'text_to_be_confirmed',
          isHidden: !this.textLists.textToBeConfirmedSummary || this.textLists.textToBeConfirmedSummary.length === 0,
          items: this.textLists.textToBeConfirmedSummary,
        },
        {
          name: 'email',
          isHidden: !this.texts.emailTextProductOrder,
          validators: [isValidEmail],
        },
        {
          name: 'email_verification',
          isHidden: !this.texts.emailTextProductOrder || !this.isEmailVerification,
          validators: [isValidEmail, { handler: isEqualTo('email'), hint: 'substore.email_addresses_do_not_match' }],
        }
      ),
      rescissionLong: false,
    };
  },

  methods: {
    onSubmit({ values }) {
      this.$emit('submit', values);
    },
  },
};
</script>

<style scoped>
.button-bar > span {
  position: relative;
  top: 1px;
  display: inline-block;
}
</style>
